import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import ReactDom from "react-dom";

import StaffMessage from "../../../Hooks/StaffMessage";
import StaffReview from "../../../Hooks/StaffReview"
import { addtoCartEnum, utils } from "../../../utils/Utils";
import StencilRows from "../../Binding/StencilRows";
import { UserContext } from "../../Definitions/UserContext";
// Import other necessary dependencies and components

import RenderStarRating from "../../Icons/StarRating";
import OopsBanner, { NoRecordsBanner } from "../../OopsBanner";
import { AsyncAjaxGet } from "../../Utilities/AsyncAjaxService";

const avatarSize = "4.5em";
const avatarStyle = { width: avatarSize, height: avatarSize, borderRadius: "50%" };

const defaultImageUrls = [
    "https://res.cloudinary.com/vagaro/image/upload/v1701719058/MySite/team-member-3_qiblxw.png",
    "https://res.cloudinary.com/vagaro/image/upload/v1701719056/MySite/team-member-1_rweura.png",
    "https://res.cloudinary.com/vagaro/image/upload/v1701719055/MySite/team-member-4_yovo2e.png",
    "https://res.cloudinary.com/vagaro/image/upload/v1701719055/MySite/team-member-2_hnyg2k.png",
    "https://res.cloudinary.com/vagaro/image/upload/v1701719055/MySite/team-member-5_serzz0.png"

    // ... add more URLs as needed
];



export default function RenderStaffMember({ staffMember, siteData, isStenciled, serviceList, layout}: { staffMember: any, siteData: UserContext, isStenciled: boolean, serviceList: any, layout: string }) {
    //validate data and replace with empty strings to avoid extra checks during rendering
    if (!staffMember.businessSummary)
        staffMember.businessSummary = "";
    if (!staffMember.spLargePhotoUrl)
        staffMember.spLargePhotoUrl = "";
    if (!staffMember.reviewRank)
        staffMember.reviewRank = 0;
    if (!staffMember.reviewCount)
        staffMember.reviewCount = 0;
    if (!staffMember.firstName)
        staffMember.firstName = "";
    if (!staffMember.lastName)
        staffMember.lastName = "";

    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    var BusinessData = utils.MultiLocationData(siteData, siteData.bidHash);
    return (
        <div className="flex-column" style={{ alignContent: "center", width: "100%" }}>
            <div className="flex-row-to-column align-center gap-large" style={{ margin: "10px", cursor: "pointer" }} onClick={(event) => !IsEditor && (window as any).Staffreview(staffMember, siteData)}>

                {typeof staffMember.photoURL != 'undefined' && staffMember.photoURL != null && staffMember.photoURL != "" &&
                    <div className="staff-image-border" style={{ background: `url(${staffMember.photoURL})`, borderRadius: "100%", width: avatarSize, height: avatarSize, backgroundSize: "cover", backgroundPosition: "center", border: "1px solid  #ccc" }}></div>
                }

                {(typeof staffMember.photoURL == 'undefined' || staffMember.photoURL == null || staffMember.photoURL == "") &&
                    <div className="  center-all"
                        style={{
                            background: `#e7e7e7`,
                            border: '1px solid #cdcdcd',
                            color: "#333",
                            borderRadius: "50%",
                            width: avatarSize,
                            height: avatarSize,


                        }}>
                        <div className="staff-image-border review-profile-inner-div intialsname h-full w-full xvg-avatar-inital center-all stencil-item" style={{ border: "1px solid #cdcdcd", borderRadius: "100px" }}>
                            <div className="review-profile-inner vg-avatar-inital-inner ">
                                <div className="review-profile-inner-text w-full">{staffMember.spintials}
                                </div>
                            </div>
                        </div>
                    </div>}

                <div>
                    <h3 className="text-align-center-mobile" style={{ maxWidth: "500px", wordBreak: "break-word" }}>{staffMember.firstName} {staffMember.lastName}</h3>
                    <div className="staff-reviews">
                        <div className="flex-row align-center gap-large stencil-item review-icon-rating-staff">
                            <div className="flex-row gap-small">
                                {!isStenciled && <RenderStarRating rating={Math.round(staffMember.reviewRank)} starColor="yellow" isOutlined={false} />}
                            </div>
                            <div className="vp-2" style={{ paddingTop: ".2em" }}>({staffMember.reviewCount})</div>
                        </div>
                    </div>
                    <div className="staff-phone stencil-item text-align-center-mobile" style={{ marginTop: "4px", color: "inherit" }}>{staffMember.cell}</div>
                </div>
            </div>
            {isStenciled ?
                <StencilRows rowCount={3} />
                :
                <div className="vp-2" style={{ padding: "0px 16px", textAlign: "left" }}>{staffMember.businessSummary}</div>
            }
            <div className="flex-row justify-end w-full">
                <div className="gap-large flex-row-to-column booknowdrp full-width-mobile" style={{ padding: "10px 16px", textAlign: "right" }}>
                    {staffMember.isShowMessage && (
                        BusinessData.vagaroConnectBeta ? (
                            <button id="MessageControlStaff" className="invisible-button v-button secondary full-width-mobile center-all" onClick={(event) => !IsEditor && (window as any).StaffMessageConnect(staffMember, siteData, event)}>
                                <svg className='Message-margin' height="1em" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path d="M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" fill="currentColor"></path>
                                </svg>
                                Message
                            </button>
                        ) : (
                            <button className="invisible-button v-button secondary full-width-mobile center-all" onClick={() => !IsEditor && (window as any).StaffMessage(staffMember, siteData, BusinessData)}><i className="fal fa-envelope bicon"></i>Message</button>
                        )
                    )}

                    {serviceList > 0 && staffMember.isAllowBook ? staffMember.isServiceTab && staffMember.isClassTab ?
                        <Dropdown>
                            <Dropdown.Toggle bsPrefix="invisible-button v-button primary full-width-mobile" id="dropdown-basic">
                                {staffMember.bookText}<i className="bicon2 fal fa-angle-down"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => !IsEditor && (window as any).BookStaffSerice(staffMember, BusinessData)} className="no-a">Services</Dropdown.Item>
                                <Dropdown.Item onClick={() => !IsEditor && (window as any).BookStaffClass(staffMember, BusinessData)} className="no-a">Classes</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        :
                        <button type="button" onClick={() => !IsEditor && (window as any).BookServiceClass(staffMember, BusinessData)} className="invisible-button v-button primary full-width-mobile">{staffMember.bookText}</button>
                        : ""}
                </div>
            </div>
        </div>
    )
}